import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { forgotPassword } from '../controllers/user';
import { Link } from 'react-router-dom';
import { useToast } from '../components/toast/ToastContext';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const showToast = useToast();
  useEffect(() => {
    document.title = 'FAMA - Olvidé Contraseña';
  }, []);
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const r = await forgotPassword(email);
      showToast({
        message: r.message,
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Correo enviado'
      });
    }
    catch (e) {
      showToast({
        message: e.message,
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al enviar correo'
      });
    }
  }

  return (
    <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>
          <h1>olvidé contraseña</h1>
          <Form className='mt-4 mb-4' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={e => setEmail(e.target.value)} />
            </Form.Group>
            <Button variant="primary" type="submit">
              Enviar
            </Button>
          </Form>
          <p><Link to={'/login'}>Iniciar sesión</Link></p>
          <p>¿Aún no tienes cuenta? <Link to={'/registro'}>Crea una cuenta nueva</Link>.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;
